exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.file-finder-overlay[data-v-28937e50] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 200;\n}\n.file-finder[data-v-28937e50] {\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.diff-file-changes[data-v-28937e50] {\n  top: 50px;\n  max-height: 327px;\n}\n", ""]);

